import React, { useEffect, useCallback, useState} from 'react';
import '../../../Scenes.scss';
import {connect} from 'react-redux';
import SubMixComponent from "components/mix/SubMixComponent.js"


const ZSubMix = ({zobject}) => { 
    return (<SubMixComponent sequencerEngine={zobject.sequencerEngine}/>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZSubMix);
